import styled, { keyframes } from "styled-components";

const expandRight = keyframes`
  0% { left: 50%; width: 0%; }
  100% { left: 50%; width: 50%; }
`;

const expandLeft = keyframes`
  0% { right: 50%; width: 0%; }
  100% { right: 50%; width: 50%; }
`;

const contractRight = keyframes`
  0% { left: 50%; width: 50%; }
  100% { left: 50%; width: 0%; }
`;

const contractLeft = keyframes`
  0% { right: 50%; width: 50%; }
  100% { right: 50%; width: 0%; }
`;

export const StyledNav = styled.nav`
  position: relative;
  display: flex;
  min-width: 0;
  white-space: nowrap;
  background-image: linear-gradient(to right, #1d428a 75%, #2a63d2);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 2;
`;

export const StyledUL = styled.ul`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[3]};
  margin: 0;
  padding-inline-start: ${({ theme }) => theme.space[4]};
  padding-inline-end: ${({ theme }) => theme.space[4]};
  min-width: 0;
  white-space: nowrap;
  list-style: none;
  overflow-x: scroll;
  overflow-y: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .ism-nav__tab {
    position: relative;
    display: inline-block;
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: ${({ theme }) => theme.fontSizes[1]};
    font-weight: 700;
    line-height: 2;
    text-decoration: none;

    &::before,
    &::after {
      position: absolute;
      bottom: 0;
      height: 3px;
      content: "";
      background-color: #ffdb4d;
    }

    &::before {
      border-top-left-radius: ${({ theme }) => theme.radii[2]};
    }

    &::after {
      border-top-right-radius: ${({ theme }) => theme.radii[2]};
    }

    @media (prefers-reduced-motion: reduce) {
      &::before,
      &::after {
        animation: none !important;
      }
    }
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .ism-nav__tab.active {
    font-weight: 900;

    &::before {
      left: 0;
      width: 50%;
    }

    &::after {
      right: 0;
      width: 50%;
    }
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .ism-nav__tab:not(.active)::before {
    animation: ${contractLeft} 0.1s ease-in-out forwards;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .ism-nav__tab:not(.active)::after {
    animation: ${contractRight} 0.1s ease-in-out forwards;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .ism-nav__tab:not(.active):hover::before {
    animation: ${expandLeft} 0.1s ease-in-out forwards;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  .ism-nav__tab:not(.active):hover::after {
    animation: ${expandRight} 0.1s ease-in-out forwards;
  }
`;

export const NavContainer = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  width: 100%;
  min-width: 0;
`;
